require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./honey-with-ricotta-lemon-and-walnut-lace-cookies.json") })
        }
      }, "path---honey-with-ricotta-lemon-and-walnut-lace-cookies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---honey-with-ricotta-lemon-and-walnut-lace-cookies!./.cache/json/honey-with-ricotta-lemon-and-walnut-lace-cookies.json
// module id = 482
// module chunks = 231608221292675